import React from 'react';
import media from '../../consts/media';

const contacts = [
  {
    name: "linkedin",
    text: "linkedin.com/in/sharmaraj2302",
  },
  {
    name: "github", 
    text: "github.com/dankevil",
  },
  {
    name: "email",
    text: media.emailRaw,
  }
];

const Contacts = ({ t }) => {
  return (
    <section className="contacts" id="contacts">
      <h2 className="h2">{t.title}</h2>
      <div className="contacts__content">
        <p className="contacts__description">{t.text}</p>
        <div className="contacts__media">
          <h3 className="contacts__title">{t.media}</h3>
          <div className="contacts__list">
            {contacts.map(contact => (
              <a 
                key={contact.name}
                className="contact" 
                href={media[contact.name]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={`/images/icons/${contact.name}.svg`} alt="" />
                <div className="contact__name">{contact.text}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
